/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterAlertMapping extends models.JiraDataCenterMappingBase {
    getFixupPrototypeFunction() { return JiraDataCenterAlertMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterAlertMapping>): JiraDataCenterAlertMapping {
        let obj = Object.assign(new JiraDataCenterAlertMapping(), model);
        JiraDataCenterAlertMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterAlertMapping>): JiraDataCenterAlertMapping {
        if (!model) return null;
        return JiraDataCenterAlertMapping.newInstance(<JiraDataCenterAlertMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterAlertMapping) {
        if (!obj) return;

        models.JiraDataCenterAlertMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterAlertMapping): boolean {
        if (models.JiraDataCenterMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraDataCenterAlertMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    selected_description_attributes: Array<models.JiraDataCenterAlertDescriptionAttribute>;

    selected_summary_attributes: Array<models.JiraDataCenterAlertSummaryAttribute>;

}
